import { lazy, Suspense } from 'react';
import { SiteHeader } from '../../components/SiteHeader';
import { SiteFooter } from '../../components/SiteFooter';
import { HeroSection } from '../../components/landing/HeroSection';
import { TrustBand } from '../../components/landing/TrustBand';
import { LazySection } from '../../components/landing/LazySection';

// Below-the-fold sections are code-split and mounted only as they near the
// viewport (LazySection + React.lazy), keeping the hero payload lean.
const FeaturesBento = lazy(() =>
  import('../../components/landing/FeaturesBento').then((m) => ({ default: m.FeaturesBento })),
);
const AiTransparency = lazy(() =>
  import('../../components/landing/AiTransparency').then((m) => ({ default: m.AiTransparency })),
);
const JpComplianceBand = lazy(() =>
  import('../../components/landing/JpComplianceBand').then((m) => ({ default: m.JpComplianceBand })),
);
const Comparison = lazy(() =>
  import('../../components/landing/Comparison').then((m) => ({ default: m.Comparison })),
);
const HowItWorks = lazy(() =>
  import('../../components/landing/HowItWorks').then((m) => ({ default: m.HowItWorks })),
);
const PricingTeaser = lazy(() =>
  import('../../components/landing/PricingTeaser').then((m) => ({ default: m.PricingTeaser })),
);
const FaqSection = lazy(() =>
  import('../../components/landing/FaqSection').then((m) => ({ default: m.FaqSection })),
);
const CtaSection = lazy(() =>
  import('../../components/landing/CtaSection').then((m) => ({ default: m.CtaSection })),
);

export function LandingPage() {
  return (
    <div className="min-h-screen flex flex-col bg-background">
      <SiteHeader />
      <main className="flex-1">
        {/* 1 — Hero (cinematic) */}
        <HeroSection />

        {/* 2 — Trust band */}
        <TrustBand />

        {/* 3 — Feature showcase (7 wedges) */}
        <LazySection minHeight={640}>
          <Suspense fallback={null}>
            <FeaturesBento />
          </Suspense>
        </LazySection>

        {/* 4 — AI transparency demo */}
        <LazySection minHeight={520}>
          <Suspense fallback={null}>
            <AiTransparency />
          </Suspense>
        </LazySection>

        {/* 5 — JP compliance band */}
        <LazySection minHeight={520}>
          <Suspense fallback={null}>
            <JpComplianceBand />
          </Suspense>
        </LazySection>

        {/* 6 — Comparison */}
        <LazySection minHeight={520}>
          <Suspense fallback={null}>
            <Comparison />
          </Suspense>
        </LazySection>

        {/* 7 — How it works */}
        <LazySection minHeight={420}>
          <Suspense fallback={null}>
            <HowItWorks />
          </Suspense>
        </LazySection>

        {/* 8 — Pricing teaser + FAQ + CTA */}
        <LazySection minHeight={640}>
          <Suspense fallback={null}>
            <PricingTeaser />
          </Suspense>
        </LazySection>
        <LazySection minHeight={420}>
          <Suspense fallback={null}>
            <FaqSection />
          </Suspense>
        </LazySection>
        <LazySection minHeight={360}>
          <Suspense fallback={null}>
            <CtaSection />
          </Suspense>
        </LazySection>
      </main>
      <SiteFooter />
    </div>
  );
}

/** Legacy Footer export kept so older imports keep compiling. */
export { SiteFooter as Footer } from '../../components/SiteFooter';
